var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div id=\"close-account-modal\" class=\"modal_div new_form popup\"><div ng-style=\"{'background': theme_color}\" class=\"header\"><h2>Close Account</h2><a title=\"Close\" href=\"#\" ng-click=\"$dismiss()\" class=\"fancybox-item fancybox-close\"></a></div><div class=\"modal_content\"><h3>Sorry to see you go!</h3><br><h4 style=\"text-align:center;\">To deactivate your account, please contact our support desk M-F 9:30am - 4:30pm CST </h4><br><h4 style=\"text-align:center;\">(312) 500-3121</h4></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/closeAccountModal/closeAccountModal.jade
// module id = 783
// module chunks = 0